import SharepointIntegration from './SharepointIntegration';

export default SharepointIntegration;
